module.exports = __webpack_public_path__ + "static/media/hoan_tien_3.e453aebd.png";